<template>
  <section class="su-tests">
    <div class="su-title">
      <h2>не знаете какой класс подойдет?</h2>
    </div>

    <div class="su-tests__row">
      <div class="su-tests__info">
        <div class="su-tests__info_cheaps">
          <span>тест</span>
          <span>2 минуты</span>
          <span>6 вопросов</span>
        </div>

        <h4>пройдите <br> экспресс‑тест</h4>
        <p>
          пройдите экспресс-тест и&nbsp;узнайте, какой класс вам&nbsp;больше подходит,
          а&nbsp;так&nbsp;же&nbsp;получите индивидуальный карьерный портрет
        </p>
      </div>

      <div
        v-if="currentQuestionIndex < questions.length"
        class="su-tests__test"
      >
        <h5 v-html="currentQuestion.title" />
        <p class="su-tests__test_text">
          <img
            src="/v2/school-university/tests/accent.svg"
            alt="*"
            loading="lazy"
          >
          можно выбрать несколько ответов
        </p>
        <div class="su-tests__test_checkboxes">
          <label
            v-for="(checkbox, index) in currentQuestion.variants"
            :key="index"
          >
            <input
              v-model="currentQuestion.answers"
              type="checkbox"
              :value="checkbox.value"
            >
            <div class="su-tests__test_checkbox" />
            <span v-html="checkbox.text" />
          </label>
        </div>
        <p
          v-if="emptyError"
          class="su-tests__test_error"
        >
          *похоже вы ничего не отметили, выберите наиболее подходящее
        </p>
        <p class="su-tests__test_text su-tests__test_count">
          вопрос {{ currentQuestionIndex + 1 }} из {{ questions.length }}
        </p>
        <button
          class="m-btn su-tests__test_btn"
          @click="nextQuestion"
        >
          далее
        </button>
      </div>

      <div
        v-show="currentQuestionIndex === questions.length"
        :class="`su-tests__test ${showResult ? 'su-tests__result' : 'su-tests__lead'}`"
      >
        <h5>оставьте номер и узнайте какой класс вам подходит больше всего</h5>

        <div class="su-tests__results">
          <div
            v-for="(result, idx) in results"
            :key="idx"
            class="su-tests__results_item"
          >
            <p>
              {{ result.value }}
              <span>%</span>
            </p>
            <span>{{ result.specification }}</span>

            <img
              v-if="idx === 0"
              src="/v2/school-university/tests/plug_1.svg"
              alt="вам подойдет"
              class="plug-1"
              loading="lazy"
            >
            <img
              v-else
              src="/v2/school-university/tests/plug_2.svg"
              alt="доп. класс"
              class="plug-2"
              loading="lazy"
            >
          </div>
        </div>

        <div
          v-show="!showResult"
          class="su-tests__form"
        >
          <p class="su-tests__form_text">
            <img
              src="/v2/school-university/tests/star.svg"
              alt="star"
              loading="lazy"
            >
            консультация с экспертом по профориентации в подарок!
          </p>
          <form-phone-field
            ref="phoneField"
            v-model="phoneInput"
            class="su-tests__form_field"
            placeholder="ваш номер телефона"
            round-border
          />

          <span class="su-tests__form_privacy">
            нажимая на кнопку, вы соглашаетесь
            с&nbsp;<nuxt-link
              to="/privacy"
              target="_blank"
            >условиями обработки данных</nuxt-link>
            в&nbsp;соответствии
            с&nbsp;<nuxt-link
              to="/privacy"
              target="_blank"
            >политикой конфиденциальности</nuxt-link>
          </span>

          <button
            class="m-btn su-tests__test_btn"
            @click="submit"
          >
            открыть результаты
          </button>
        </div>

        <div
          v-if="showResult"
          class="su-tests__complete"
        >
          <p>поздравляем! для&nbsp;вас&nbsp;подарок&nbsp;—</p>

          <div class="su-tests__complete_free">
            сессия с профориентологом
          </div>

          <p>
            сотрудник отдела заботы свяжется с&nbsp;вами
            и&nbsp;назначит удобное время для&nbsp;онлайн-встречи
          </p>

          <button
            class="m-btn su-tests__complete_btn"
            @click="resetTest"
          >
            пройти еще раз
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needName: false,
});

const classes = {
  it: 'it',
  cyber: 'cyber',
  med: 'med',
  digital: 'digital',
  media: 'media',
  business: 'business',
};

const classesName = {
  [classes.it]: 'it класс',
  [classes.cyber]: 'кибер класс',
  [classes.med]: 'мед. класс',
  [classes.digital]: 'digital класс',
  [classes.media]: 'медиа класс',
  [classes.business]: 'бизнес класс',
};

function getPercentByCount(key, count) {
  if (key === classes.it || key === classes.media) {
    switch (count) {
      case 1: return 20;
      case 2: return 40;
      case 3: return 67;
      case 4: return 82;
      case 5: return 100;
      default: return 0;
    }
  }

  switch (count) {
    case 1: return 17;
    case 2: return 35;
    case 3: return 52;
    case 4: return 71;
    case 5: return 88;
    case 6: return 100;
    default: return 0;
  }
}

export default {
  name: 'SuTests',
  components: { FormPhoneField },
  mixins: [sendLeadMixin],
  data: () => ({
    emptyError: false,
    showResult: false,
    currentQuestionIndex: 0,
    questions: [
      {
        title: '1. что вы считаете сильной стороной вашего ребенка?',
        variants: [
          { value: [classes.it, classes.cyber], text: 'анализ информации и&nbsp;тяга к&nbsp;технологиям' },
          { value: [classes.med], text: 'сопереживание людям и&nbsp;стремление им&nbsp;помочь' },
          { value: [classes.digital, classes.media], text: 'креативные идеи и&nbsp;тяга к&nbsp;творчеству' },
          { value: [classes.business], text: 'тяга к&nbsp;риску, финансам и&nbsp;управлению' },
        ],
        answers: [],
      },
      {
        title: '2. какими из&nbsp;особых навыков обладает ребенок?',
        variants: [
          { value: [classes.it, classes.cyber], text: 'хорошо разбирается в&nbsp;компьютерах (может починить)' },
          { value: [classes.med], text: 'не&nbsp;боится крови, умеет оказывать первую помощь' },
          { value: [classes.digital, classes.med], text: 'отличается хорошей зрительной памятью' },
          { value: [classes.media], text: 'вам&nbsp;кажется, что&nbsp;из&nbsp;него&nbsp;выйдет хороший актер' },
        ],
        answers: [],
      },
      {
        title: '3. как бы вы описали характер вашего ребенка?',
        variants: [
          // eslint-disable-next-line max-len,vue/max-len
          { value: [classes.business, classes.media], text: 'хорошо ладит с&nbsp;людьми и&nbsp;умеет их&nbsp;мотивировать' },
          { value: [classes.cyber, classes.business], text: 'целеустремленный и&nbsp;не&nbsp;боится трудностей' },
          { value: [classes.digital], text: 'творчески подходит к&nbsp;любой задаче' },
          { value: [classes.it, classes.med], text: 'усидчив и&nbsp;может долго заниматься&nbsp;одной задачей' },
        ],
        answers: [],
      },
      {
        title: '4. что&nbsp;из&nbsp;этого&nbsp;вызывает интерес у&nbsp;ребенка?',
        variants: [
          { value: [classes.it], text: 'решение задачек на&nbsp;логику' },
          // eslint-disable-next-line max-len,vue/max-len
          { value: [classes.business], text: 'участие в&nbsp;различных конкурсах, не&nbsp;боится конкуренции' },
          { value: [classes.media, classes.digital], text: 'интересуется актуальными событиями и&nbsp;новостями' },
          { value: [classes.cyber], text: 'интересуется кибер-соревнованиями и&nbsp;турнирами' },
        ],
        answers: [],
      },
      {
        title: '5. чем&nbsp;ребенок любит заниматься в&nbsp;свободное время?',
        variants: [
          { value: [classes.cyber], text: 'проводит много времени за&nbsp;компьютерными играми' },
          { value: [classes.med], text: 'интересуется животными, растениями, анатомией человека' },
          { value: [classes.it], text: 'увлекается электроникой или&nbsp;созданием программ' },
          { value: [classes.digital], text: 'нравится придумывать новые идеи, рисовать, петь&nbsp;и&nbsp;т.д.' },
        ],
        answers: [],
      },
      {
        title: '6. во время решения сложных задач ваш ребенок может...',
        variants: [
          { value: [classes.med, classes.business], text: 'принимать решения в&nbsp;сложных ситуациях' },
          { value: [classes.cyber], text: 'быстро реагировать на&nbsp;новые обстоятельства' },
          { value: [classes.business], text: 'убеждать людей принять его&nbsp;позицию' },
          { value: [classes.media, classes.digital], text: 'работать в&nbsp;команде и&nbsp;принимать решение вместе' },
        ],
        answers: [],
      },
    ],
  }),
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex] || {};
    },
    /* eslint-disable no-param-reassign */
    results() {
      // посчитать каждый класс
      const allAnswers = this.questions.reduce((all, { answers }) => {
        answers.flat(1).forEach((answer) => {
          if (!all[answer]) all[answer] = 0;
          all[answer] += 1;
        });
        return all;
      }, {});

      const allAnswersByPercent = Object.entries(allAnswers)
        // получить значение в % в зависимости от количества
        .map(([key, count]) => [key, getPercentByCount(key, count)])
        // сортировка по убыванию
        .sort((a, b) => b[1] - a[1])
        .slice(0, 2);

      const result = allAnswersByPercent.map(([key, percent]) => ({
        specification: classesName[key],
        value: `${percent}`,
      }));

      if (result.length < 2) {
        return [];
      }

      if (this.showResult) {
        return result;
      }

      return [
        { specification: 'test test', value: '50%' },
        { specification: 'test test', value: '50%' },
      ];
    },
    /* eslint-enable */
  },
  watch: {
    // eslint-disable-next-line func-names
    'currentQuestion.answers': function (answers) {
      if (answers?.length) {
        this.emptyError = false;
      }
    },
  },
  methods: {
    nextQuestion() {
      if (!this.currentQuestion.answers.length) {
        this.emptyError = true;
        return;
      }

      this.currentQuestionIndex += 1;
      this.emptyError = false;
    },
    onSubmit() {
      this.showResult = true;
    },
    resetTest() {
      this.questions.forEach((question) => {
        // eslint-disable-next-line no-param-reassign
        question.answers = [];
      });
      this.currentQuestionIndex = 0;
    },
  },
};
</script>

<style scoped lang="scss">

.su-tests {
  .su-tests__row {
    margin-top: 2.5rem;
    height: calc(var(--scale) * 720);
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 1.25rem / 2));
    gap: 1.25rem;

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 512);
      grid-template-columns: repeat(2, calc(50% - 0.4rem));
      gap: 0.8rem;
    }

    @include media-down($size-mobile) {
      height: auto;
      grid-template-columns: 100%;
      grid-template-rows: calc(var(--scale) * 264) calc(var(--scale) * 512);
    }
  }

  .su-tests__info {
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 3.75rem;
    padding: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.6rem;
      border-radius: 3.2rem;
    }

    &_cheaps {
      margin-bottom: 1rem;
      display: flex;
      gap: 0.25rem;

      @include media-down($size-tablet) {
        margin-bottom: 2rem;
      }

      span {
        padding: calc(var(--scale) * 10) 1.25rem;

        border: 1px solid #CACACB;
        border-radius: 2.5rem;

        font-weight: 500;
        font-size: 1rem;
        line-height: 130%;
        color: #02120F;

        @include media-down($size-tablet) {
          padding: 0.6rem 1.1rem;
          font-size: 1.4rem;
        }
      }
    }

    h4 {
      margin-bottom: 1.25rem;

      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 86);
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #5237E6;

      @include media-down($size-tablet) {
        margin-bottom: 0.8rem;
        font-size: 4rem;
      }
    }

    p {
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }
    }
  }

  .su-tests__test {
    height: 100%;
    background-color: #baa7fe;
    background-image: url("/v2/school-university/tests/bg.webp");
    background-size: cover;
    border-radius: 3.75rem;
    padding: 2.5rem 2.35rem 2.5rem 2.5rem;

    display: flex;
    flex-direction: column;

    @include media-down($size-tablet) {
      padding: 2rem 1.6rem 0.8rem;
      border-radius: 3.2rem;
    }

    h5 {
      margin-bottom: 0.75rem;

      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        margin-bottom: 1.8rem;
        font-size: 2rem;
      }
    }

    .su-tests__test_text {
      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }
    }

    .su-tests__test_checkboxes {
      margin-top: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 1.25rem;

      @include media-down($size-tablet) {
        margin-top: 3.2rem;
      }

      label {
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        white-space: nowrap;

        @include media-down($size-tablet) {
          gap: 0.8rem;
          white-space: inherit;
          min-height: calc(var(--scale) * 43.5);
        }

        @media (hover: hover) {
          &:hover {
            .su-tests__test_checkbox {
              background-image: url("/v2/school-university/tests/checkbox-hover.svg");
            }

            input:checked + .su-tests__test_checkbox {
              background-image: url("/v2/school-university/tests/checkbox-active-hover.svg");
            }
          }
        }
      }

      span {
        font-style: normal;
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          font-size: 1.8rem;
        }
      }

      input {
        display: none;
      }

      .su-tests__test_checkbox {
        flex-shrink: 0;
        width: 2.75rem;
        aspect-ratio: 1 / 1;

        background-image: url("/v2/school-university/tests/checkbox.svg");
        background-size: contain;
        background-repeat: no-repeat;

        @include media-down($size-tablet) {
          width: 3.2rem;
        }
      }

      input:checked + .su-tests__test_checkbox {
        background-image: url("/v2/school-university/tests/checkbox-active.svg");
      }
    }

    .su-tests__test_error {
      margin-top: 1.25rem;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 130%;
      color: #ED131C;

      @include media-down($size-tablet) {
        margin-top: 0.5rem;
        font-size: 1.4rem;
        line-height: 1;
      }
    }

    .su-tests__test_count {
      margin-top: auto;
      text-align: center;
    }

    .su-tests__test_btn {
      margin-top: 1rem;
      width: 100%;
      padding: 2.75rem 3.5rem;
      background-color: #5237E6;
      border-radius: 2.5rem;
      transition: 300ms;

      font-style: normal;
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        width: calc(100% + 1.6rem);
        margin-left: -0.8rem;
        padding: 3rem;
        box-shadow: 1rem 1rem 5rem rgba(7, 21, 57, 0.1), 0.4rem 0.4rem 2rem rgba(7, 21, 57, 0.05);
        font-size: 1.8rem;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #846EFB;
        }
      }
    }

    .su-tests__results {
      margin-top: 0.5rem;
    }
  }

  .su-tests__lead .su-tests__results {
    .su-tests__results_item {
      span {
        filter: blur(10px);
      }

      p {
        filter: blur(20px);
      }
    }
  }

  .su-tests__results {
    display: flex;
    gap: calc(var(--scale) * 10);

    @include media-down($size-tablet) {
      margin-top: 1rem;
      flex-wrap: wrap;
      justify-content: center;
    }

    &_item {
      width: calc(50% - 10px);
      padding: 1.3rem 1.5rem;
      box-sizing: border-box;

      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;

      border: 2px solid rgba($white-color, 0.5);
      border-radius: 40px;
      background-color: rgba($white-color, 0.2);

      @include media-down($size-tablet) {
        flex-basis: calc(50% - 0.5rem);
        text-align: center;
      }

      @include media-down($size-mobile) {
        flex-direction: column;
      }

      span {
        font-style: normal;
        font-weight: 500;
        font-size: 1.8rem;
        line-height: 110%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          font-size: 1.8rem;
        }
      }

      p {
        display: flex;
        align-items: flex-end;

        font-style: normal;
        font-weight: 900;
        font-size: 5rem;
        line-height: 100%;
        text-align: center;
        letter-spacing: -0.02em;
        color: #FFFFFF;

        span {
          display: flex;
          margin-bottom: 0.3rem;
          font-size: 2rem;
          font-weight: 900;
        }

        @include media-down($size-tablet) {
          font-size: 3.5rem;
        }
      }

      img {
        position: absolute;
        right: -5px;
        top: -25px;
      }

      .plug-1 {
        @include media-down($size-mobile) {
          max-width: 118px;
        }
      }

      .plug-2 {
        @include media-down($size-mobile) {
          max-width: 95px;
        }
      }
    }
  }

  .su-tests__form {
    margin-top: auto;

    &_text {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }
    }

    &_field {
      margin-top: 1.25rem;
      margin-bottom: 0.75rem;

      @include media-down($size-tablet) {
        margin-top: 0.8rem;
      }
    }

    &_privacy {
      margin-bottom: 1.25rem;

      font-style: normal;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 130%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        font-size: 1.4rem;
      }

      a {
        color: #5237E6;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .su-tests__complete {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: auto;

    p {
      font-style: normal;
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      text-align: center;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }
    }

    &_free {
      margin: 2rem auto 1.5rem;
      padding: 2.75rem 3.5rem;

      position: relative;
      background-color: #FFFFFF;
      border-radius: 2.5rem;
      transform: rotate(-1deg);

      font-style: normal;
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #FF4F01;

      @include media-down($size-tablet) {
        width: 100%;
        padding: 3rem 1rem;
        text-align: center;
        font-size: 1.8rem;
      }

      &:after {
        content: 'бесплатно';
        padding: 0.5rem calc(var(--scale) * 14) calc(var(--scale) * 10);
        position: absolute;
        right: -10px;
        top: -5px;

        background-color: #FF5319;
        border-radius: 2.5rem;
        transform: rotate(9deg);

        font-style: normal;
        font-weight: 400;
        font-size: 1.25rem;
        line-height: 130%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          padding: 0.5rem 0.8rem
        }
      }
    }

    &_btn {
      margin-top: calc(var(--scale) * 14);

      font-style: normal;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 130%;
      text-align: center;
      text-decoration-line: underline;
      color: #5237E6;

      @include media-down($size-tablet) {
        font-weight: 500;
        font-size: 1.4rem;
      }

      &:hover {
        text-decoration: none;
      }
    }
  }
}

</style>
